import { FC, useContext, useEffect, useState } from 'react'

import { TechnicianSelectDropdownUI } from '../../components/Estimates/TechnicianSelect/TechnicianSelectDropdownUI'
import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { NotificationContext } from '../../providers'
import { useGetUsersWithPermissionQuery } from '../../redux/api'
import { useUpdateInspectionMutation } from '../../redux/api/inspectionApi'
import { GetUsersWithPermissionActEnum, InspectionEntry } from '../../sdk'

interface Props {
  inspection: InspectionEntry | undefined
  onlySetToSelf?: boolean
  customUpdateTechHandler?: (tech: string) => void
}

const TechnicianSelect: FC<Props> = ({
  inspection,
  onlySetToSelf,
  customUpdateTechHandler
}) => {
  const { accessToken, shopId, userId } = useAccessTokenAndShopId()
  const { setError } = useContext(NotificationContext)

  const { data: technicians } = useGetUsersWithPermissionQuery({
    authorization: accessToken,
    shop: shopId,
    act: GetUsersWithPermissionActEnum.IsTechnician
  })
  const [selectedTech, setSelectedTech] = useState<string>('')

  const [updateInspection] = useUpdateInspectionMutation()

  const inspectionTech = inspection?.info?.tech
  useEffect(() => {
    setSelectedTech(inspectionTech || '')
  }, [inspectionTech])

  const handleTechChange: (credit: Record<string, number>) => void = (
    credit
  ) => {
    const changedTech =
      Object.keys(credit).find((key) => credit[key] === 1) || ''
    if (onlySetToSelf && changedTech !== userId) {
      setError('You may only update the technician to yourself')
      return
    }
    setSelectedTech(changedTech)
    if (customUpdateTechHandler) {
      customUpdateTechHandler(changedTech)
    } else {
      updateInspection({
        authorization: accessToken,
        inspectionEntry: {
          ...inspection!,
          info: {
            ...inspection!.info!,
            tech: changedTech || undefined
          }
        }
      })
    }
  }

  return (
    <>
      {technicians && (
        <TechnicianSelectDropdownUI
          techFractionalCredit={{ [selectedTech]: 1 }}
          technicians={technicians}
          handleTechChange={handleTechChange}
          disabled={false}
          hideLabel
        />
      )}
    </>
  )
}

export default TechnicianSelect
